import Glide from '@glidejs/glide';
import {isMobile} from "@/utils/features";

export default function (dom, opts) {
    let options = {
        sliderOverlaySel: '.gallery-image-overlay',
        openOverlay: '[data-open-overlay]',
        closeOverlay: '[data-close-overlay]',
        showOverlayCls: 'gallery-image-overlay-open',
        activeGalleryCls: 'gallery-overlay-active',
        ...opts
    };

    let glideOptions = {
        type: 'carousel',
        perView: 1,
        gap: 0,
        keyboard: false,
        autoplay: false,
        swipeThreshold: 80,
        dragThreshold: 120,
        perTouch: 1,
        touchRatio: 0.5,
        touchAngle: 45,
        rewind: true,
    };

    const sliderOverlay = dom.querySelector(options.sliderOverlaySel);

    if (!sliderOverlay) {
        return;
    }

    const slideCountOverlay = sliderOverlay.querySelectorAll('.glide__slide').length;
    const overlayClose = [].slice.call(dom.querySelectorAll(options.closeOverlay), 0);

    const html = document.documentElement;
    const body = document.body;
    let isOverlayOpen = false;


    if (slideCountOverlay) {
        const glideOverlay = new Glide(sliderOverlay.querySelector('.glide'), glideOptions).mount();

        const openOverlayByTrigger = trigger => {
            const overlayOpen = [].slice.call(dom.querySelectorAll(options.openOverlay), 0);
            const index = overlayOpen.indexOf(trigger);
            if (index < 0) {
                return;
            }

            document.querySelectorAll(`.${options.activeGalleryCls}`).forEach(item => {
                item.classList.remove(options.activeGalleryCls);
            });

            glideOverlay.go(`=${index}`);
            isOverlayOpen = true;
            dom.classList.add(options.activeGalleryCls);
            html.classList.add(options.showOverlayCls);
        };

        [].slice.call(dom.querySelectorAll(options.openOverlay), 0).forEach(item => {
            item.addEventListener('click', () => {
                openOverlayByTrigger(item);
            });
        });

        dom.addEventListener('click', e => {
            const trigger = e.target.closest(options.openOverlay);
            if (!trigger || !dom.contains(trigger)) {
                return;
            }

            openOverlayByTrigger(trigger);
        }, true);

        overlayClose.forEach(item => {
            item.addEventListener('click', () => {
                isOverlayOpen = false;
                dom.classList.remove(options.activeGalleryCls);
                html.classList.remove(options.showOverlayCls);
            })
        });

        body.addEventListener('click', onOuterClick);

    }

    function onOuterClick(e) {
        if (!isOverlayOpen) {
            return;
        }

        if (!isMobile() && !dom.contains(e.target)) {
            isOverlayOpen = false;
            dom.classList.remove(options.activeGalleryCls);
            html.classList.remove(options.showOverlayCls);
        }
    }
}
